import { FooterLinks, SecondaryFooterLinks } from '../types';
import { defineMessage } from 'react-intl';

export const getFooterLinks = (host: string): FooterLinks => {
  return {
    popularSearches: [
      {
        link: `${host}/organizer/overview/`,
        text: defineMessage({ id: 'How it Works' }),
      },
      {
        link: `${host}/organizer/pricing/`,
        text: defineMessage({ id: 'Pricing' }),
      },
      {
        link: `${host}/blog/`,
        text: defineMessage({ id: 'Event Blog' }),
      },
    ],
    planEvents: [
      {
        link: `${host}/l/conferences/`,
        text: defineMessage({ id: 'Conference Management Software' }),
      },
      {
        link: `${host}/l/host-yoga-event/`,
        text: defineMessage({ id: 'Eventbrite + Yoga' }),
      },
      {
        link: `${host}/l/npo/`,
        text: defineMessage({ id: 'Nonprofits & Fundraisers' }),
      },
      {
        link: `${host}/l/sell-tickets/`,
        text: defineMessage({ id: 'Sell Tickets' }),
      },
      {
        link: `${host}/l/event-management-software/`,
        text: defineMessage({ id: 'Event Management & Planning' }),
      },
      {
        link: `${host}/l/registration-online/`,
        text: defineMessage({ id: 'Online Event Registration' }),
      },
      {
        link: `${host}/l/online-rsvp/`,
        text: defineMessage({ id: 'Online RSVP' }),
      },
      {
        link: `${host}/l/music-venues/`,
        text: defineMessage({ id: 'Music Venues & Promoters' }),
      },
      {
        link: `${host}/l/onsite/`,
        text: defineMessage({ id: 'Event Equipment & Staffing' }),
      },
      {
        link: `${host}/l/eventbrite-sales-contact/`,
        text: defineMessage({ id: 'Eventbrite Sales Number' }),
      },
    ],
    findEvents: [
      {
        link: `${host}/d/online/events/`,
        text: defineMessage({ id: 'Browse Online Events' }),
      },
      {
        link: `${host}/l/eventbrite-app/`,
        text: defineMessage({ id: 'Get the Eventbrite App' }),
      },
    ],
    connectWithUs: [
      {
        link: '',
        text: defineMessage({ id: 'Report this event' }),
        refTarget: 'report-this-event-button',
      },
      {
        link: `${host}/help/en-us/`,
        text: defineMessage({ id: 'Help Center' }),
      },
      {
        link: `${host}/help/en-us/articles/251210/eventbrite-terms-of-service/`,
        text: defineMessage({ id: 'Terms' }),
      },
      {
        link: `${host}/help/en-us/articles/460838/eventbrite-privacy-policy/`,
        text: defineMessage({ id: 'Privacy' }),
      },
      {
        link: `${host}/help/en-us/articles/212596/supplemental-privacy-notice-for-california-residents/`,
        text: defineMessage({ id: 'CA Privacy Notice' }),
      },
      {
        link: `${host}/l/accessibility/`,
        text: defineMessage({ id: 'Accessibility' }),
      },
      {
        link: `${host}/l/community-guidelines/`,
        text: defineMessage({ id: 'Community Guidelines' }),
      },
    ],
  };
};

export const getSecondaryFooterLinks = (host: string): SecondaryFooterLinks => {
  return {
    manageCookiePreferences: {
      link: '#',
      text: defineMessage({ id: 'Manage Cookie Preferences' }),
    },
    doNotSellPersonalInfo: {
      link: '#',
      text: defineMessage({ id: 'Do Not Sell or Share My Personal Information' }),
    },
    privacy: {
      link: `${host}/help/en-us/articles/251210/eventbrite-terms-of-service/`,
      text: defineMessage({ id: 'Privacy' }),
    },
  };
};
